<template>
  <b-form-group :label="item.field.prompt">
    <b-form-textarea v-model="item.value"
                     :disabled="item.disabled"
                     rows="5"
                     :maxlength="item.field.max_length"
                     :required="item.field.mandatory"
                     :state="isValid">
    </b-form-textarea>
    <b-form-invalid-feedback :state="isValid">{{errorMessage}}</b-form-invalid-feedback>
  </b-form-group>
</template>


<script>

export default {
  name: 'MultiLineTextField',
  props: {
    item: { type: Object }
  },
  data () {
    return { isValid: null, errorMessage: '' }
  },
  computed: {
  },
  methods: {
    validate () {
      this.isValid = true
      this.errorMessage = ''
      if (this.item.field.mandatory && (this.item.value == null || this.item.value.length === 0)) {
        this.isValid = false
        this.errorMessage = 'Please complete'
      }
      return this.isValid
    },
    value () {
      return { field_name: this.item.field.field_name, string_value: this.item.value }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data_entry/MultiLineTextField.vue